import React, { useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import RoutePath from 'app/router/RoutePath';
import { STATUS_CODE } from 'common/Constants';
import store from 'app/store';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container } from '@mui/system';
import VerticalStepper from './common/verticalStepper';
import ScenarioInformation from './scenarioInformation';
import Demograhpic from './demographic';
import Policy from './policy';
import Coverage from './coverage';
import Output from './output';
import ComparePlans from './comparePlans';
import {
  resetScenario, updateScenarioSection,
  updateHospitalIndemnityPayout,
  updateCriticalIllnessPayout, updateAccidentPayout,
  updateClaimWeight, updateCategoryCode, updateCoveragePage,
} from './state/reducer';
import {
  getClaimById, getCriticalIllnessById, getHospitalIndemnityById,
  getAccidentById, getPolicyAdjustmentsById, getEnrollCondConsts,
  getDemographicById, getById, getPolicyInfo, getCustomTextByScenarioId, getParticipationPerc,
  getCIPremiums, getHIACPremiums, getCurrentBenefits,
} from './state/service';

export default function Navigate() {
  const navigate = useNavigate();

  let nameDefaultValue = '';
  const scenario = useSelector((state) => state.scenario.scenario);
  if (scenario?.name) {
    nameDefaultValue = scenario.name.charAt(0).toUpperCase() + scenario.name.slice(1);
  }
  const processStatus = useSelector((state) => state.scenario.processStatus);
  const currPage = useSelector((state) => state.scenario.scenarioSection);
  const steps = useSelector((state) => state.auth.steps);
  const claimFetchFlag = useSelector((state) => state.scenario.claimFetchFlag);
  const claimHoldFlag = useSelector((state) => state.scenario.claimHoldFlag);
  const participationPercentages = useSelector((state) => state.scenario.participationPercentages);
  const hospitalIndemnityPayoutFlag = useSelector(
    (state) => state.scenario.hospitalIndemnityPayoutFlag,
  );
  const criticalIllnessPayoutFlag = useSelector(
    (state) => state.scenario.criticalIllnessPayoutFlag,
  );
  const accidentPayoutFlag = useSelector(
    (state) => state.scenario.accidentPayoutFlag,
  );

  const claimWeightUpdateFlag = useSelector(
    (state) => state.scenario.claimWeightUpdateFlag,
  );
  const hospitalIndemnityObject = useSelector((state) => state.scenario.hospitalIndemnityObject);
  const criticalIllnessObject = useSelector((state) => state.scenario.criticalIllnessObject);
  const accidentObject = useSelector((state) => state.scenario.accidentObject);
  const HIProductIncluded = useSelector((state) => state.scenario.includeProductHI);
  const CIProductIncluded = useSelector((state) => state.scenario.includeProductCI);
  const ACProductIncluded = useSelector((state) => state.scenario.includeProductAC);
  const isNoProductIncluded = !HIProductIncluded && !CIProductIncluded && !ACProductIncluded;
  const permissions = useSelector((state) => state.auth.permissions);
  const brokerCode = useSelector((state) => state.auth.brokerCode);
  const hasComparePlans = permissions?.COMPARE_PLANS;
  const HIPayoutDetail = useSelector((state) => state.scenario.HIPayoutDetail);
  const CIPayoutDetail = useSelector((state) => state.scenario.CIPayoutDetail);
  const ACPayoutDetail = useSelector((state) => state.scenario.ACPayoutDetail);
  const atLeastoneHIChecked = HIPayoutDetail
    .filter((benefit) => hospitalIndemnityObject[`${benefit?.name}Checked`])
    .filter((benefit) => benefit?.code !== null).length > 0;
  const atLeastoneCIChecked = CIPayoutDetail
    .filter((benefit) => criticalIllnessObject[`${benefit?.name}Checked`])
    .filter((benefit) => benefit?.code !== null).length > 0;
  const atLeastoneACChecked = ACPayoutDetail
    .filter((benefit) => accidentObject[`${benefit?.name}Checked`])
    .filter((benefit) => benefit?.code !== null).length > 0;
  const effectiveHISelected = HIProductIncluded ? atLeastoneHIChecked : false;
  const effectiveCISelected = CIProductIncluded ? atLeastoneCIChecked : false;
  const effectiveACSelected = ACProductIncluded ? atLeastoneACChecked : false;
  const atLeastOneBenefitSelected = !isNoProductIncluded && (
    effectiveHISelected || effectiveCISelected || effectiveACSelected);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams && searchParams.get('id')) {
      store.dispatch(getById(searchParams.get('id')));
    } else {
      store.dispatch(resetScenario());
    }
  }, [searchParams]);

  const handleCancelCreation = () => {
    store.dispatch(resetScenario());
    const link = RoutePath.app.scenario.fullpath;
    navigate(link);
  };

  const goToPreviousPage = () => {
    if (((brokerCode && currPage === 5) || (!brokerCode && currPage === 4))
      && isNoProductIncluded) {
      store.dispatch(updateScenarioSection(2));
    } else {
      store.dispatch(updateScenarioSection(Math.max(currPage - 1, 0)));
      if (HIProductIncluded) {
        store.dispatch(updateCoveragePage(0));
      } else if (CIProductIncluded) {
        store.dispatch(updateCoveragePage(1));
      } else {
        store.dispatch(updateCoveragePage(2));
      }
    }
  };

  const goToNextPage = () => {
    window.scrollTo(0, 0);
    if (currPage === 2) {
      if (isNoProductIncluded) {
        store.dispatch(updateScenarioSection(steps.length - 1));
      } else {
        store.dispatch(updateScenarioSection(3));
        if (HIProductIncluded) {
          store.dispatch(updateCoveragePage(0));
        } else if (CIProductIncluded) {
          store.dispatch(updateCoveragePage(1));
        } else {
          store.dispatch(updateCoveragePage(2));
        }
      }
    } else if (currPage === 3 && !atLeastOneBenefitSelected) {
      store.dispatch(updateScenarioSection(steps.length - 1));
    } else {
      store.dispatch(updateScenarioSection(Math.min(currPage + 1, steps.length - 1)));
    }
  };

  const bottomBarFunctions = { handleCancelCreation, goToNextPage, goToPreviousPage };

  useEffect(() => {
    if (searchParams && searchParams.get('id') && processStatus === STATUS_CODE.SUCCESS) {
      store.dispatch(getClaimById(searchParams.get('id')));
    } else {
      // store.dispatch(resetDemographic());
    }
  }, [claimFetchFlag, searchParams, processStatus]);

  useEffect(() => {
    store.dispatch(updateHospitalIndemnityPayout());
  }, [hospitalIndemnityPayoutFlag, claimHoldFlag, participationPercentages]);

  useEffect(() => {
    store.dispatch(updateCriticalIllnessPayout());
  }, [criticalIllnessPayoutFlag, claimHoldFlag, participationPercentages]);

  useEffect(() => {
    store.dispatch(updateAccidentPayout());
  }, [accidentPayoutFlag, claimHoldFlag, participationPercentages]);

  useEffect(() => {
    store.dispatch(updateClaimWeight());
  }, [claimWeightUpdateFlag]);

  useEffect(() => {
    store.dispatch(getPolicyInfo()).unwrap().then(() => {
      if (searchParams && searchParams.get('id') && processStatus === STATUS_CODE.SUCCESS) {
        const scenarioId = searchParams.get('id');
        store.dispatch(getDemographicById(scenarioId));
        store.dispatch(getHospitalIndemnityById(scenarioId));
        store.dispatch(getCriticalIllnessById(scenarioId));
        store.dispatch(getAccidentById(scenarioId));
        store.dispatch(getPolicyAdjustmentsById(scenarioId));
        store.dispatch(getEnrollCondConsts());
        store.dispatch(getCustomTextByScenarioId(scenarioId));
        store.dispatch(getParticipationPerc({ scenarioId, policyCode: 'HI' }));
        store.dispatch(getParticipationPerc({ scenarioId, policyCode: 'AC' }));
        store.dispatch(getCIPremiums(scenarioId));
        store.dispatch(getHIACPremiums(scenarioId));
        if (hasComparePlans) {
          store.dispatch(getCurrentBenefits(scenarioId));
        }
      }
      store.dispatch(updateCategoryCode());
    });
  }, [searchParams, processStatus]);

  useEffect(() => {
    const scenarioId = searchParams.get('id');
    if (scenarioId && hasComparePlans) {
      store.dispatch(getCurrentBenefits(scenarioId));
    }
  }, [hasComparePlans]);

  useEffect(() => {
    const scenarioId = searchParams.get('id');
    if (scenarioId) {
      store.dispatch(getById(scenarioId));
    }
  }, [searchParams]);

  const renderCurrPage = () => {
    const code = steps[currPage]?.code;
    switch (code) {
      case 'SCENARIO_INFORMATION':
        return <ScenarioInformation bottomBarFunctions={bottomBarFunctions} />;
      case 'DEMOGRAPHICS':
        return <Demograhpic bottomBarFunctions={bottomBarFunctions} />;
      case 'POLICIES':
        return <Policy bottomBarFunctions={bottomBarFunctions} />;
      case 'COVERAGE':
        return <Coverage bottomBarFunctions={bottomBarFunctions} />;
      case 'COMPARE_PLANS':
        return <ComparePlans bottomBarFunctions={bottomBarFunctions} />;
      case 'OUTPUT':
        return <Output bottomBarFunctions={bottomBarFunctions} />;
      default:
        return null;
    }
  };

  return (
    <main>
      <Grid container padding={3}>
        <Grid item xs={12}>
          <Typography component="h1" variant="h4" mystyle="pageHeader">
            {searchParams.get('id') ? `${(nameDefaultValue)} Scenario` : 'Create a Scenario'}
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid container item xs={2} direction="column" sx={{ minWidth: '240px' }}>
            <VerticalStepper />
          </Grid>

          <Grid container item xs={9}>
            <Container sx={{ minWidth: '1200px' }}>
              {renderCurrPage()}
            </Container>
          </Grid>
          <Grid item xs={1} />
        </Grid>

      </Grid>
      <Box component="footer" sx={{ fontSize: '0.8rem', marginBottom: '45px' }}>
        Claritev Inc. All Rights Reserved.
      </Box>
    </main>
  );
}
